const Policy = (props) => {
    return (  
        <div className="policy container" style={{ padding: "15px" }}>
            <div className="right">
                <strong><p>All Rights Reserved | DEVSPRIME 2021 </p></strong>
            </div>
            <div className="privacy"><strong><p>Privacy <span>Policy</span> </p></strong> 
            <strong><p className="site">Site <span className="credits">Credits</span></p></strong>            
            </div>      
        </div>
    );
}
export default Policy;
